/**
 * AboutPanel for a group
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import Avatar from 'components/media/Avatar/index.jsx';
import ColorBlock from 'components/media/ColorBlock/index.js';
import messages from '../messages.js';
import EditModal from '../EditModal/index.jsx';
import avatarImageStyle from '../avatarImageStyle.js';
import EditButton from '../../../../interaction/EditButton.js';

const Wrapper = styled(Card)`
  ${avatarImageStyle}
  .color-block {
    width: 32px;
    height: 32px;
  }
  dl {
    dt {
      position: absolute;
      width: 6.5em;
      /* font-weight: normal; */
      color: ${(p) => p.theme.gray};
      text-align: right;
    }
    dd {
      margin-left: 7.5em;
      margin-bottom: 1em;
    }
  }
`;

function AboutPanel(props) {
  const [showEdit, setShowEdit] = useState(false);
  const { group } = props;
  const { theme } = group;
  const editTitle = { ...messages.edit, values: group };
  return (
    <Wrapper>
      <Card.Header className="border-0 d-flex">
        <h4 className="flex-grow-1"><FormattedMessage {...messages.about} values={group} /></h4>
        <EditButton className="fs-3" aria-label="Edit group info" onClick={() => setShowEdit(true)} />
      </Card.Header>
      <Card.Body>
        <dl>
          {theme.themeColor && (
            <div>
              <dt><FormattedMessage {...messages.groupColor} /></dt>
              <dd><ColorBlock color={theme.themeColor} /></dd>
            </div>
          )}
          {theme.logo && (
            <>
              <dt><FormattedMessage {...messages.logo} /></dt>
              <dd><Avatar src={theme.logo} group retry={10} /></dd>
            </>
          )}
          {group.theme.tagLine && (
            <>
              <dt><FormattedMessage {...messages.tagLine} /></dt>
              <dd>{group.theme.tagLine}</dd>
            </>
          )}
        </dl>
      </Card.Body>
      <EditModal show={showEdit} title={editTitle} group={group} onHide={() => setShowEdit(false)} />
    </Wrapper>
  );
}

AboutPanel.propTypes = {
  group: PropTypes.object,
};

export default AboutPanel;
